export default function WhatIsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-medium tracking-wider uppercase rounded-full bg-secondary-100 text-secondary-700">
            What Is Basetao Spreadsheet
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-4">
            What Is Basetao Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Basetao Spreadsheet is a curated resource system that helps international shoppers discover products, compare options, and organize shopping research efficiently. Instead of searching thousands of products manually, users can access organized collections including fashion, sneakers, streetwear, accessories, and lifestyle products.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <div className="flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
              <i className="ri-search-line text-lg"></i>
            </span>
            <div>
              <h4 className="font-label font-semibold text-foreground-900 text-sm mb-1">Product Discovery</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">Find popular products faster with organized collections instead of manual searching.</p>
            </div>
          </div>
          <div className="flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
              <i className="ri-scales-3-line text-lg"></i>
            </span>
            <div>
              <h4 className="font-label font-semibold text-foreground-900 text-sm mb-1">Price Research</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">Compare products and prices before buying to make informed purchasing decisions.</p>
            </div>
          </div>
          <div className="flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
              <i className="ri-folder-chart-line text-lg"></i>
            </span>
            <div>
              <h4 className="font-label font-semibold text-foreground-900 text-sm mb-1">Shopping Organization</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">Save hours of research time by accessing pre-organized product spreadsheets.</p>
            </div>
          </div>
          <div className="flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
              <i className="ri-group-line text-lg"></i>
            </span>
            <div>
              <h4 className="font-label font-semibold text-foreground-900 text-sm mb-1">Community Resources</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">Learn from experienced international buyers and tap into a growing knowledge community.</p>
            </div>
          </div>
        </div>

        <div className="mt-10 max-w-2xl mx-auto overflow-hidden rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="px-5 py-3 text-left font-label font-semibold text-foreground-800 text-xs">Feature</th>
                <th className="px-5 py-3 text-left font-label font-semibold text-primary-600 text-xs">Basetao Spreadsheet</th>
                <th className="px-5 py-3 text-left font-label font-semibold text-foreground-500 text-xs">Traditional Search</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-background-200/50">
                <td className="px-5 py-3 text-foreground-700">Product Discovery</td>
                <td className="px-5 py-3 text-foreground-800 font-medium">Organized Collections</td>
                <td className="px-5 py-3 text-foreground-500">Manual Searching</td>
              </tr>
              <tr className="border-t border-background-200/50">
                <td className="px-5 py-3 text-foreground-700">Research Speed</td>
                <td className="px-5 py-3 text-foreground-800 font-medium">Fast</td>
                <td className="px-5 py-3 text-foreground-500">Slow</td>
              </tr>
              <tr className="border-t border-background-200/50">
                <td className="px-5 py-3 text-foreground-700">Comparison</td>
                <td className="px-5 py-3 text-foreground-800 font-medium">Easy</td>
                <td className="px-5 py-3 text-foreground-500">Difficult</td>
              </tr>
              <tr className="border-t border-background-200/50">
                <td className="px-5 py-3 text-foreground-700">Beginner Friendly</td>
                <td className="px-5 py-3 text-foreground-800 font-medium">High</td>
                <td className="px-5 py-3 text-foreground-500">Medium</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}